import $i18n from 'panda-i18n';
import React, { useEffect, useState } from 'react';
import { CnButton } from '@/components/cn-button';
import { CnSafeArea } from '@/components/cn-safe-area';
import { CnDrawer } from '@/components/cn-drawer';
import { CnList } from '@/components/cn-list';
import { findInArray } from '@/utils/func';
import Option from '../option';
import { removeItemFromArray } from '../util';
export default function SelectedListDrawer(props) {
    const { prefix, innerValue, renderItem } = props;
    const { visible, onOk, onCancel } = props;
    const clsPrefix = `${prefix}select`;
    const [selectedList, setSelectedList] = useState([]);
    const handleOk = () => onOk(selectedList);
    const handleItemClick = (item) => {
        const isSelected = findInArray(selectedList, (it) => it.value === item.value);
        if (isSelected) {
            const arr = removeItemFromArray(selectedList, item.value);
            setSelectedList(arr);
        }
        else {
            setSelectedList([...selectedList, item]);
        }
    };
    useEffect(() => setSelectedList(innerValue), [innerValue]);
    return (React.createElement(CnDrawer, { visible: visible, closeMode: ['mask'], className: `${clsPrefix}-confirm-drawer`, containerClassName: `${clsPrefix}-confirm-drawer-container`, onClose: onCancel, noCard: true },
        React.createElement("div", { className: `${clsPrefix}-confirm-drawer-header` },
            React.createElement("span", { className: `${clsPrefix}-confirm-total` }, $i18n.get({
                id: 'TheSelectedListLengthItemIsCurrentlySelected_1841163092',
                dm: '当前已选中 {selectedListLength} 项',
                ns: 'CnSelect',
            }, { selectedListLength: selectedList.length })),
            React.createElement(CnButton, { type: "primary", text: true, onClick: handleOk }, $i18n.get({ id: 'Finish', dm: '完成', ns: 'CnSelect' }))),
        React.createElement("div", { className: `${clsPrefix}-confirm-drawer-body` },
            React.createElement(CnList, null, innerValue.map((item) => {
                const selected = findInArray(selectedList, (it) => it.value === item.value);
                return (React.createElement(Option, { selected: selected, key: item.value, onClick: () => handleItemClick(item) }, typeof renderItem === 'function'
                    ? renderItem(item)
                    : item.label));
            }))),
        React.createElement(CnSafeArea, { className: `${clsPrefix}-safe-area` })));
}
SelectedListDrawer.displayName = 'SelectedListDrawer';
